import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import {
    Absence,
    AbsenceDetailsApiDataResponse,
    AbsenceListOrder,
    AbsenceListResponse,
} from '../Models/Absence/Absence';
import { BaseApiDataResponse } from '../Models/ApiData';
import { BaseDataService } from './Base/BaseDataService';

export const AbsenceEndpoints = {
    CREATE_ABSENCE: '/api/v1/back/compagnons/absences',
    ABSENCE: (absenceId: string) => `/api/v1/back/compagnons/absences/${absenceId}`,
    ABSENCES: '/api/v1/back/compagnons/absences',
    EXPORT_ABSENCE_LIST: '/api/v1/back/compagnons/absences/export',
};

export interface IAbsenceDataService {
    createAbsence: (
        absence: Absence,
        cts: XHRRequestCanceler
    ) => Promise<AbsenceDetailsApiDataResponse>;

    getAbsence: (
        cts: XHRRequestCanceler,
        absenceId: string
    ) => Promise<AbsenceDetailsApiDataResponse>;

    updateAbsence: (
        absenceId: string,
        absence: Absence,
        cts: XHRRequestCanceler
    ) => Promise<AbsenceDetailsApiDataResponse>;

    deleteAbsence: (absenceId: string, cts: XHRRequestCanceler) => Promise<BaseApiDataResponse>;

    listAbsence: (
        params: {
            search?: string;
            order?: AbsenceListOrder;
        },
        cts: XHRRequestCanceler
    ) => Promise<AbsenceListResponse>;
}

class AbsenceDataService extends BaseDataService implements IAbsenceDataService {
    public createAbsence = (
        absence: Absence,
        cts: XHRRequestCanceler
    ): Promise<AbsenceDetailsApiDataResponse> => {
        const body = {
            compagnon_id: absence.compagnon.compagnon_id,
            ...absence,
        };
        return this.post(AbsenceEndpoints.CREATE_ABSENCE, body, cts);
    };

    public getAbsence = (
        cts: XHRRequestCanceler,
        absenceId: string
    ): Promise<AbsenceDetailsApiDataResponse> => {
        return this.get(AbsenceEndpoints.ABSENCE(absenceId), cts);
    };

    public updateAbsence = (
        absenceId: string,
        absence: Absence,
        cts: XHRRequestCanceler
    ): Promise<AbsenceDetailsApiDataResponse> => {
        const body = {
            ...absence,
        };
        return this.patch(AbsenceEndpoints.ABSENCE(absenceId), body, cts);
    };

    public deleteAbsence = (
        absenceId: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return this.delete(AbsenceEndpoints.ABSENCE(absenceId), cts);
    };

    public listAbsence = (
        params: { search?: string | undefined; order?: AbsenceListOrder | undefined },
        cts: XHRRequestCanceler
    ): Promise<AbsenceListResponse> => {
        return this.get(AbsenceEndpoints.ABSENCES, cts, { params });
    };
}

const AbsenceDataServiceName = 'AbsenceDataService';
export { AbsenceDataService, AbsenceDataServiceName };
